import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from "jquery";
import image from './cog.svg';

class CurrentlyRevised extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
  	}

  	handleClick(event)
  	{
  		$('.navbar-collapse').removeClass("show");
  	}

  	render() {
    	return (
	    		<div className="container marginTop50px">
            <div className="row">
              <div id="text" className="col-12 text-center padding10px">
                <img src={image} className="image" alt="logo" />
              </div>
            </div>
            <div className="row paddingTop50px">
              <div id="text" className="col-12 text-center padding10px">
                <span>Diese Seite wird aktuell &uuml;berarbeitet und wird in K&uuml;rze f&uuml;r Sie wieder vollst&auml;ndig erreichbar sein.</span>
              </div>
            </div>
	    		</div>
	    );
	}
}

export default CurrentlyRevised;


// WEBPACK FOOTER //
// ./src/CurrentlyRevised.js